import { type WPAuthorType } from '@/defs/wordpress'
import { cn } from '@/utils/commonUtil'

import { ArticleAuthorLink } from '../ArticleAuthorLink/ArticleAuthorLink'

import styles from './ArticleAuthorBio.module.scss'

type Props = {
  author?: WPAuthorType
  colorScheme?: 'strong'
  hideName?: boolean
  linkDisabled?: boolean
}

export const ArticleAuthorBio = ({ author, colorScheme, hideName, linkDisabled }: Props) =>
  author && (
    <div className={cn(styles.container, { colorScheme, styles })}>
      {author.avatarUrl && (
        <ArticleAuthorLink
          className={cn(styles.avatar, { linkDisabled, styles })}
          disabled={linkDisabled}
          slug={author.slug}
        >
          <img alt={author.name} decoding='async' loading='lazy' src={author.avatarUrl} />
        </ArticleAuthorLink>
      )}
      <div className={styles.info}>
        {!hideName && (
          <h3>
            <ArticleAuthorLink slug={author.slug}>{author.name || 'EDHREC'}</ArticleAuthorLink>
          </h3>
        )}
        {author.description && <p dangerouslySetInnerHTML={{ __html: author.description }} />}
      </div>
    </div>
  )
